// Deep links into the admin panel (e.g. /panel/eventos/11/etapas/50).
//
// router/index.js's staff-only guard can't let these through until the
// websocket has resumed/created a staff session - which on a hard refresh or
// a link opened in a new tab hasn't happened yet when the router first
// navigates. Instead of losing the URL, the guard stashes it here and sends
// the user to Login; client.js's handle_client() then consumes it the moment
// it sees a staff user (session resumed or freshly logged in) and navigates
// there instead of the default Panel landing.
//
// sessionStorage (per tab, like the websocket's own event_session) so it
// survives Login's page reloads but never leaks into another tab.
const KEY = 'pending_admin_route';

export function save_pending_admin_route(full_path){
    try{ sessionStorage.setItem(KEY, full_path); }catch(ex){ /* storage unavailable */ }
}

export function take_pending_admin_route(){
    try{
        const path = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        return path;
    }catch(ex){
        return null;
    }
}

export function clear_pending_admin_route(){
    try{ sessionStorage.removeItem(KEY); }catch(ex){ /* storage unavailable */ }
}
